<template>
    <div class="page flex-col">
        <my-menu class="sticky-menu" :default-active-index="2"></my-menu>
        <home-banner class="home-banner" ></home-banner>
        <home-about></home-about>
        <ChpcValues></ChpcValues>
        <home-main></home-main>
        <ChpcFooter></ChpcFooter>
        <contact-float />
    </div>
</template>
<script>
    import myMenu from "@/views/Component/ChpcMenu.vue";
    import ContactFloat from "@/views/Component/Contact.vue";
    import ChpcValues from "@/views/Component/ChpcValues";

    import ChpcFooter from "@/views/Component/ChpcFooter";

    export default {
        name: "homeIndex",
        data() {
            return {
                constants: {}
            };
        },
        //
        components:{
            myMenu,ChpcValues,ContactFloat,ChpcFooter
        },
        methods: {}
    };
</script>
<style scoped lang="css" src="./css/index.css" />
